<!-- 图片链接列表：模块头+图片+标题+链接 -->
<template>
<div class="content-block">
  <div class="info-list-title">
  </div>
  <div class="info-list-content">
    <div class="list-container">
      <div class="list-container-cell" v-for="(news,index) in newsList" :style="{'width': celWidth}">
        <a v-bind:style="{backgroundImage:'url('+require('./../../assets/home_gg_'+(index+1)+'.png')+')'}">
          <div class="cell-base-info">
            <div class="base-info-title">广告</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'ImgLink03',
  props: {
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    col: {
      type: String,
      default: '3'
    },
    count: {
      type: String,
      default: '3'
    }
  },
  data() {
    return {
      celWidth: "calc(100%/" + this.col + ")",
      newsList: []
    }
  },
  created:function(){
    this.newsList=this.Global.imgInfoList.slice(0,this.count);;
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
a {
  color: #42b983;
  text-decoration: none;
}

.list-container {
  display: flex;
  flex-wrap: wrap;
  padding-bottom:10px;
}

.list-container-cell {
  box-sizing: border-box;
  height: 160px;
  background: #fff;
  border: 0px solid red;
}

.list-container-cell a {
  display: block;
  box-sizing: border-box;
  padding:0px;
  margin:10px;
  border-radius:8px;
  background-color: #fff;
  border:1px solid #eee;
  background-repeat: no-repeat;
  background-position: center center;
}

.list-container-cell a:hover{
  border:1px solid #eee;
  box-shadow:0px 0px 1px 1px #eee;
}

.list-container-cell .cell-base-info{
  position:relative;
  height:140px;
  width:100%;
  color:#fff;
  border-radius:10px;
  padding-right:0px;

}

.cell-base-info .base-info-title{
  float:right;
  height:24px;
  padding:3px 10px 3px 10px;
  margin-left:80px;
  font-size:12px;
  font-weight:100;
  border-radius:0px 8px 0px 8px;
  background:orange;
}

.cell-base-info .base-info-label{
  float:left;
  height:30px;
  margin-left:80px;
  font-size:14px;
  line-height:20px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  left:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:35px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

</style>



// WEBPACK FOOTER //
// src/components/block/ImgLink03.vue